export default __webpack_public_path__ + "static/media/butter.b6e89873.png";